/**
 * Which prices to show this visitor: the region guessed from the browser's
 * time zone, unless they picked another one on this device.
 *
 * Used by the landing page and the app alike, so the price a visitor reads on
 * one is the price the other sells. A guess and a choice, never a gate: anyone
 * may pick any region -- EU law requires the EU price to be open to every EU
 * customer -- and the card's country is checked after the purchase instead
 * (alignRegion in server/src/lib/billing.js).
 */

import { countryOfTimeZone } from './timezones.js';
import { regionOfCountry, currencyFor, priceOf } from './plans.js';

const KEY = 'pt-price-region';

/** The region and currency the browser's time zone points to. Unknown places see the international price. */
export function detectRegion(zone) {
  let name = zone;
  if (name === undefined) {
    try { name = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { name = null; }
  }
  const country = countryOfTimeZone(name);
  const region = regionOfCountry(country);
  return { region, currency: currencyFor(region, country), country };
}

/** What to show: the visitor's own pick if they made one here, else the guess. */
export function priceRegion() {
  try {
    const saved = globalThis.localStorage?.getItem(KEY);
    if (saved) {
      const [region, currency] = saved.split(':');
      if (priceOf(region, currency, 'month') !== null) return { region, currency, picked: true };
    }
  } catch {
    /* Private mode or blocked storage: the guess will do. */
  }
  return { ...detectRegion(), picked: false };
}

/** Remembers a pick on this device; the server never stores it. */
export function rememberRegion(region, currency) {
  try {
    globalThis.localStorage?.setItem(KEY, region + ':' + currency);
  } catch {
    /* Not remembered -- it still applies to this visit. */
  }
}
